var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0.5V13.2834L15.2719 18.7595H10.977L8.11389 21.5H5.24887V18.7595H0V4.15215L1.43186 0.5H21ZM3.34037 15.5644H7.63789V18.3012L10.5003 15.565H15.7492L19.0915 12.3687V2.32515H3.34037V15.5644ZM8.59117 5.97915H10.4997V11.4571H8.59053L8.59117 5.97915ZM13.8407 5.97915H15.7492V11.4571H13.8407V5.97915Z",
    fill: "#8E92AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.b43ebee88c9cbd1c945951ea853d4bf5.svg";
export { ForwardRef as ReactComponent };